export default __webpack_public_path__ + "static/ScottPhoto-6619456d255ff28fab55283aa6e1a7d4.png";